<div class="home-articles max-width-1 m-auto font2">
    <h2>Articole</h2>

    <div *ngFor="let blogItem of blogItems">
        <div class="home-article">
            <div class="home-article-img">
                <a href="/blog-post?id={{blogItem.id}}">
                    <img [src]="blogItem.imageURL || '../assets/img/blog-img/3.png'" alt="article" />
                </a>
            </div>

            <div class="home-article-content font1">
                <a href="/blog-post?id={{blogItem.id}}">
                    <h3>{{ blogItem.title }}</h3>
                </a>
                <p>
                    {{ blogItem.summary || 'Blog-ul nu are sumar.' }}
                </p>
                <div>{{ blogItem.User.firstName }} {{ blogItem.User.lastName }}</div>
                <span><i class="lni lni-calendar"></i> {{ blogItem.publishedDate | date: 'MMM d, y'
                    }} | <i class="lni lni-comments-alt"></i> {{ blogItem.commentsCount || 0 }} Comment{{
                    blogItem.commentsCount === 1 ? '' : 's' }}</span>
            </div>
        </div>
    </div>

</div>